<template>
    <footer>
    	<img  v-if="hover == true" src="../image/qrcode_wechat.jpeg" alt="link" style="position: fixed; bottom: 160px;right: 430px;">
        <div class="container">
        	
            <div class="logo">
                <img src="../image/footerLogo.png" alt="footerLogo">
            </div>
            <div class="footInfo" >
            
                <h2> {{$t('footer.tel')}}010-55648823</h2>
                <h2>{{$t('footer.Email')}}makeinsight@makeins.cn</h2>
                <div class="add">
                    <h2>{{$t('footer.title')}}</h2><div class="address" style="font-size: 12px;height: 24px; line-height: 24px;color: #DADADA;margin-left:0px;">{{$t('footer.address')}}</div>
                </div>
            </div>
            <div class="footInfo">
                <ul class="linkImg">
                	<!--
                    <li><a href="javascript:void(0);"><img src="../image/link1.png" alt="link"></a></li>
                    <li><a href="javascript:void(0);"><img src="../image/link2.png" alt="link"></a></li>
                    -->
                    <li>
                    	<a href="javascript:void(0);" @mouseover="hover = true"  @mouseleave="hover = false"><img src="../image/link3.png" alt="link"></a>
                    </li>
                    <!--
                    <li><a href="javascript:void(0);"><img src="../image/link4.png" alt="link"></a></li>
                     -->
                </ul>
                <h2>{{$t('footer.copyright')}}</h2>
                <h2 style="margin-top:5px;" @click="jump()"> {{$t('footer.code')}}</h2>
               
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "MyFooter",
        data(){
            return{
                flag:true,
                hover: false,
            }
        },
        mounted(){
            console.log(this.flag)
            if (this.$i18n.locale == 'en_US') {
                    this.flag = true
                } else {
                    this.flag = false
                }
        },
         methods: {
		  jump(){
			window.location.href="http://beian.miit.gov.cn/";
		  },
		  
		}
    }
</script>

<style lang="scss" scoped>
    footer{
        padding: 40px 0;
        background: #5B6C79;
        .container{
            .logo{
                margin-left: 146px;
                float: left;
                img{
                    width:110px;
                }
            }
            .footInfo{
                float: left;
                margin-left: 84px;
                height: 104px;
                border-left: 1px solid #979797;
                width:300px;
                h2{
                    font-size: 12px;
                    height: 24px;
                    line-height: 24px;
                    color: #DADADA;
                    margin-left: 16px;
                }
                .linkImg{
                    margin-left: 16px;
                    overflow: hidden;
                    margin-bottom: 12px;
                    li{
                        margin-right: 8px;
                        float: left;
                        a{
                            display: block;
                            img{
                                width: 26px;
                            }
                        }
                        &:last-child{
                            margin-right: 0;
                        }
                    }

                }
            }
        }
    }
    .add{
        width: 284px;
        display: flex;
    }
    .address{
        word-wrap: break-word;
    }
</style>
